import * as React from "react";
import {useForm} from "react-hook-form";
import {useState} from "react";
import {ButtonInput} from "../../components/ButtonInput/ButtonInput";
import "./LoginPage.scss"
import {getAccessToken, setActiveUser} from "../../services/AuthService";
import {ResponseStatus} from "../../core/types";
import {useNavigate} from "react-router-dom";
import {TextInputPassword} from "../../components/TextInputPassword/TextInputPassword";
import {TextInputWithIcon} from "../../components/TextInputWithIcon/TextInputWithIcon";
import {useTranslation} from "react-i18next";

export const LoginPage = () => {

    const [username, setUsername] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [message, setMessage] = useState<string>("");

    const navigate = useNavigate();
    const {t} = useTranslation();

    const {
        control,
        formState: { errors },
        handleSubmit,
        reset,
        setValue
    } = useForm({
        mode: 'all',
    });

    const onSubmit = () => {
        getAccessToken(username, password).then((result) => {
            if (result.data.status == ResponseStatus.SUCCESS ) {
                let user = result.data.result.user
                user.accessToken = result.data.result.token
                if (user.status == 'ACTIVE') {
                    setActiveUser(user)
                    navigate(`/dashboard`)
                } else {
                    setMessage(`${t('Korisnik postoji, ali nije u aktivnom statusu. Obratite se administratoru sistema.')}`)
                }
            } 
        }).catch(() => setMessage(`${t('Podaci koje ste uneli nisu validni.')}`))
    };

    const onError = () => {

    };

    return <div className="login-content">
        <a className="login-logo" href="/"><img src="/images/rwa-logo.png" alt='logo'/></a>
        <div className="login-fields">
            <div className="login-field">
                <TextInputWithIcon
                    id='username'
                    value={username}
                    onValueChange={(prop, value) => setUsername(value as string)}
                    labelText={t('Username')}
                    placeholderText={t('Username')}
                    control={control}
                    setValue={setValue}
                    errors={errors}
                    rules={{ required: true }}
                    icon='bi bi-person'
                    iconAlign='left'
                    onKeyPress={(e) => {
                        if (e.key === 'Enter') onSubmit();
                    }}
                />
            </div>
            <div className="login-field">
                <TextInputPassword
                    id='password'
                    value={password}
                    onValueChange={(prop, value) => setPassword(value as string)}
                    labelText={t('Password')}
                    placeholderText={t('Password')}
                    control={control}
                    setValue={setValue}
                    errors={errors}
                    rules={{ required: true }}
                    icon='bi bi-person'
                    iconAlign='left'
                    feedback={false}
                    onKeyPress={(e) => {
                        if (e.key === 'Enter') onSubmit();
                    }}
                />
            </div>
            {message && <div>{message}</div>}
            <ButtonInput
                labelText='Login'
                onButtonClick={handleSubmit(onSubmit, onError)}
                addStyle={{background: "rgba(0, 165, 83, 1)", border: "none", marginTop: "1rem", width: "4.5rem"}}
            />
        </div>
    </div>
}
